export const DATE_WITH_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const LUXON_DATE_WITH_TIMEZONE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZZ";
//# sourceMappingURL=date.js.map